import React, { useState } from 'react';
import './index.scss';
import { useIntl } from 'umi';
import WhiteTick from '../../../svg/white-tick.svg';
import CommonBubble from '@home/components/CommonBubble';
import DS1 from '@/pages/aigc/assets/ds-image1.png';
import DefaultAvatar from '@/pages/aigc/assets/svg/default-avatar.svg';
import BasicImage from '@home/components/BasicImage';
import { PERMISSION_URL } from '../../../config/constant';

interface IDSExpertAgentCardProps {
  hasPermission?: boolean;
  title: string;
  content: string;
  author: {name: string; img: string;};
  diagram: string; 
  isSelected: boolean;
  handleOnClick?: () => void;    
}

const DSExpertAgentCard = ({
  hasPermission = false,
  title,
  content,
  author,
  diagram,
  isSelected,
  handleOnClick,
}: IDSExpertAgentCardProps) => {
  const { formatMessage, locale } = useIntl();
  const [imgErr, setImgErr] = useState(false);

  return (
    <CommonBubble
      placement="top"
      content={<>{formatMessage({id: 'dba_no_permission_desc'})}<a href={PERMISSION_URL}>{PERMISSION_URL}</a></> }
      className={'dba-ds-expert-card-bubble-box'}
      style={{ display: hasPermission ? 'none' : 'block' }}
    >
      <div 
        className={`dba-ds-expert-card ${isSelected && 'dba-ds-expert-card-selected'}`} 
        onClick={handleOnClick} 
      >
        <span className={'dba-ds-permission-box'} data-has-permission={hasPermission} data-eng-locale={locale === 'en-US'}>
          {hasPermission 
            ? (isSelected ? <img src={WhiteTick} alt="Got Permission Tick" draggable={false} /> : null) 
            : formatMessage({id: 'dba_no_permission'})}
        </span>

        <div className={'dba-ds-expert-card-title'}>{title}</div>
        <div className={'dba-ds-expert-card-content'}>{content}</div>
        <div className={'dba-ds-expert-card-author'}>
          <BasicImage 
            src={author.img || DefaultAvatar} 
            errorSrc={DefaultAvatar} 
            alt="Author Image" 
          />
          <span>{author.name}</span>
        </div>

        <img src={imgErr ? DS1 : diagram} className={'dba-ds-expert-card-diagram'} draggable={false}  onError={() => setImgErr(true)}/>
      </div>
    </CommonBubble>
    
  );};

export default DSExpertAgentCard;